<template>
  <main class="content">
    <Hero title="Over Suwo"/>
    <article class="block maxw--waist rendered" v-html="$md.render(data?.content || '')">
    </article>
  </main>
</template>

<script lang="ts" setup>
import type AboutPage from '@/typings/strapi/pages/aboutPage';

const { findOne } = useStrapi(); 

const { data } = await useAsyncData(
  'about-page',
  () => findOne<AboutPage>('about-page', { populate: ['header'] }),
  {
    transform: flattenObject
  }
)

useHead({
  title: 'Over'
});

definePageMeta({
  pageTransition: pageTransitionConfig,
});
</script>
